import { ru, enUS, es } from 'date-fns/locale';

/** BCP 47 tag for Intl.* APIs */
export function getIntlLocaleTag(locale) {
  if (locale === 'en') return 'en-US';
  if (locale === 'es') return 'es-419';
  return 'ru-RU';
}

/** date-fns locale object */
export function getDateFnsLocale(locale) {
  if (locale === 'en') return enUS;
  if (locale === 'es') return es;
  return ru;
}

/** Second argument to String.localeCompare for sorted lists */
export function getSortLocale(locale) {
  if (locale === 'en') return 'en';
  if (locale === 'es') return 'es';
  return 'ru';
}
